export function truncateGeoJSONDisplay(geojson: Record<string, any>) {
  const truncatedGeoJSON = structuredClone(geojson);
  function processGeometry(obj: any) {
    if (!obj) return;

    const nonRecursiveTypes = ["Point", "MultiPoint", "LineString", "MultiLineString", "Polygon", "MultiPolygon"];
    if (nonRecursiveTypes.includes(obj.type)) {
      obj.coordinates = "##COORDINATES##";
    } else if (obj.type === "GeometryCollection" && obj.geometries) {
      obj.geometries.forEach(processGeometry);
    }
  }

  // Process each feature in a FeatureCollection
  if (truncatedGeoJSON.type === "FeatureCollection" && truncatedGeoJSON.features) {
    truncatedGeoJSON.features.forEach((feature: any) => {
      if (feature.geometry) processGeometry(feature.geometry);
    });
  } else if (truncatedGeoJSON.type === "Feature" && truncatedGeoJSON.geometry) {
    processGeometry(truncatedGeoJSON.geometry);
  } else {
    processGeometry(truncatedGeoJSON);
  }
  const displayString = JSON.stringify(truncatedGeoJSON, undefined, 2);
  return displayString.replace(/"##COORDINATES##"/g, "[ ... ]");
}

export function stripNonPolygonalFeatures(features: Record<string, any>[]) {
  const nonPolygonalTypes = ["Point", "MultiPoint", "LineString", "MultiLineString"];
  return features.filter((feature) => !nonPolygonalTypes.includes(feature.geometry.type));
}

// Batch by payload size
export function batchFeatures<T>(items: T[], maxBatchSizeBytes: number): T[][] {
  const batches: T[][] = [];
  if (!items || !items.length) return batches;
  if (!maxBatchSizeBytes || maxBatchSizeBytes <= 0) {
    throw new Error("Maximum batch size must be a positive number");
  }

  let currentBatch: T[] = [];
  let currentBatchSize = 0;

  for (const item of items) {
    const itemSize = new TextEncoder().encode(JSON.stringify(item)).length;

    if (itemSize > maxBatchSizeBytes) {
      throw new Error(`Item size (${itemSize} bytes) exceeds maximum batch size (${maxBatchSizeBytes} bytes)`);
    }

    // If adding this item would exceed the current batch size limit, start a new batch
    if (currentBatchSize + itemSize > maxBatchSizeBytes) {
      batches.push(currentBatch);

      currentBatch = [item];
      currentBatchSize = itemSize;
    } else {
      currentBatch.push(item);
      currentBatchSize += itemSize;
    }
  }

  // Add the last batch
  if (currentBatch.length > 0) batches.push(currentBatch);

  return batches;
}
